<template>
  <SearchPage
    endpoint="news"
    :title="entity.title"
    group-by="group"
    :filter-titles="{
      organization: $texts('pressReleaseSender', 'Absender'),
      date: 'Datum',
    }"
  >
    <template v-if="tagLabels" #post-filter-title>
      <ul>
        <li
          v-for="tagLabel in tagLabels"
          :key="tagLabel.id"
          class="button is-sm mr-10"
        >
          {{ tagLabel.label }}
        </li>
      </ul>
    </template>
    <template #default="{ hit }">
      <SearchResultPressRelease v-bind="hit" />
    </template>
  </SearchPage>
</template>

<script lang="ts" setup>
definePageMeta({
  name: 'news',
  drupalFrontendRoute: true,
  ariaLive: 'off',
  languageMapping: {
    de: '/news',
    en: '/en/news',
    fr: '/fr/derniere-nouvelles',
    it: '/it/notizia',
  },
})
const route = useRoute()

// Extract tag IDs from query.
const tagIds = computed<string[]>(() => {
  if ('tags' in route.query && typeof route.query.tags === 'string') {
    return route.query.tags.split(':')
  }

  return []
})

// Build query args
const tagLabelsQueryArgs = computed(() => {
  return {
    tagsFilter: tagIds.value,
  }
})

// Fetch tag labels.
const { data: fetchedTagLabels } = await useAsyncGraphqlQuery(
  'tagLabels',
  tagLabelsQueryArgs,
  {
    transform: (v) => v.data.entityQuery.items,
  },
)

// Determine tag labels.
const tagLabels = computed(() => {
  if (fetchedTagLabels.value?.length) {
    return fetchedTagLabels.value
  }

  return []
})

const { entity } = await useDrupalRouteQuery('page')
await renderPageDependencies()
</script>
